import React, { useState } from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import Pagination from '@/components/ui/pagination';

// ── Mobile card ───────────────────────────────────────────────────────────────
function ReferralCard({ item }) {
    return (
        <Card>
            <CardContent className="p-4 space-y-2">
                <div className="flex items-start justify-between gap-2">
                    <div className="min-w-0">
                        <p className="font-semibold text-sm truncate">{item.userName}</p>
                        <p className="text-xs text-muted-foreground truncate">{item.email}</p>
                    </div>
                    <Badge variant="secondary" className="shrink-0 text-xs">{item.groupNumber}</Badge>
                </div>
                <p className="text-xs text-muted-foreground border-t pt-2">
                    Referral Date: <span className="text-foreground font-medium">{item.referralDate}</span>
                </p>
            </CardContent>
        </Card>
    );
}

// ── Main component ────────────────────────────────────────────────────────────
function Refferals_list({ Referrals }) {
    const [pageOfItems, setPageOfItems] = useState([]);

    return (
        <Card>
            <CardHeader>
                <div className="flex items-center justify-between">
                    <h3 className="text-xl font-semibold text-foreground">Your Referrals</h3>
                    <Badge variant="secondary" className="text-base">
                        Total Referrals: {Referrals.length}
                    </Badge>
                </div>
            </CardHeader>
            <CardContent>
                {Referrals != null && Referrals.length > 0 ? (
                    <div className="space-y-4">
                        {/* ── Desktop table (md and above) ── */}
                        <div className="hidden md:block rounded-md border overflow-x-auto">
                            <Table>
                                <TableHeader>
                                    <TableRow>
                                        <TableHead className="text-primary">User Name</TableHead>
                                        <TableHead className="text-primary">Group Number</TableHead>
                                        <TableHead className="text-primary">Email</TableHead>
                                        <TableHead className="text-primary">Referral Date</TableHead>
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    {pageOfItems.length > 0 ? (
                                        pageOfItems.map((uitem, _index) => (
                                            <TableRow key={_index + uitem.userName}>
                                                <TableCell className="font-medium">{uitem.userName}</TableCell>
                                                <TableCell>{uitem.groupNumber}</TableCell>
                                                <TableCell>{uitem.email}</TableCell>
                                                <TableCell>{uitem.referralDate}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={4} className="text-center py-8 text-muted-foreground">
                                                No records found
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </div>

                        {/* ── Mobile cards (below md) ── */}
                        <div className="md:hidden space-y-3">
                            {pageOfItems.length > 0 ? (
                                pageOfItems.map((uitem, _index) => (
                                    <ReferralCard key={_index + uitem.userName} item={uitem} />
                                ))
                            ) : (
                                <Card>
                                    <CardContent className="text-center py-8 text-muted-foreground">
                                        No records found
                                    </CardContent>
                                </Card>
                            )}
                        </div>

                        <Pagination items={Referrals} onChangePage={setPageOfItems} />
                    </div>
                ) : (
                    <div className="text-center py-12">
                        <p className="text-muted-foreground">No records found</p>
                    </div>
                )}
            </CardContent>
        </Card>
    );
}

export default Refferals_list;
